// extracted by mini-css-extract-plugin
export var container = "_10d-0";